import React, {  useState } from 'react';
import SoftBox from "components/SoftBox";
import Grid from "@mui/material/Grid";
import SoftTypography from "../../../components/SoftTypography";
import SoftInput from "../../../components/SoftInput";
import {  useDispatch as usePanelDispath } from 'react-redux';
import { useCheckAuth } from "../../../customHooks/useCheckAuth";
import { doConfigurarIdleSesion } from "../../../store/thunk/auth";
import Swal from "sweetalert2";
import Personas from "../../../Repository/Personas";

function ConfigurarTiempoSesion() {
  const panelDispath = usePanelDispath();
  const { user  } = useCheckAuth();
  const [tiempoC, setTiempoC] = useState(user?.idle_timeout??null);

  const storeTiempoInactividadSesion = async () => {
    const isInvalid = !tiempoC || isNaN(tiempoC);
    if(isInvalid)
    {
      Swal.fire({
        title: 'Notificaciones',
        text: 'Tiempo de inactividad inválido.',
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      });
      setTiempoC(user.idle_timeout);
      return false;
    }else{
      const personaO = new Personas();
      const result = await personaO.updateTiempoSesion(user.uuid,tiempoC);
      if(result.status === "error")
      {
        Swal.fire({
          title: 'Notificaciones',
          text: result.response.error,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false
        });
        return  false;
      }else{
        Swal.fire({
          title: 'Notificaciones',
          text: result.response.text,
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false
        });
        await panelDispath( doConfigurarIdleSesion(tiempoC) )
      }
    }

  }

  return(
    <>
        <Grid container>
          <Grid item xs={12} md={12} xl={12}>
            <SoftBox mb={1} lineHeight={0}>
              <SoftTypography variant="caption" color="text">
                Cerrar mi sesión tras (minutos) de inactividad:
              </SoftTypography>
            </SoftBox>
            <SoftBox pt={1} pb={1}>
              <SoftInput placeholder="minutos"
                         maxLength="5"  type="number"
                         value={ tiempoC } onChange={ e => setTiempoC( e.target.value) }
                         onBlur = { storeTiempoInactividadSesion }

              />
            </SoftBox>
          </Grid>
        </Grid>
    </>
  )

}

ConfigurarTiempoSesion.propTypes = {
};
export default ConfigurarTiempoSesion;